import Vue from 'vue'
import VueCompositionAPI, { inject } from '@vue/composition-api'
import Router from 'vue-router'

Vue.use(VueCompositionAPI)

export function useRouter(): Router {
    return <Router>inject('router')
}